// TypeScript types matching the backend WriteoffWorklistView
export interface WriteoffWorklistView {
  writeoffId: string;
  caseId: string;
  accountNumber: string;
  writeoffStatus: string;
  lastName: string;
  firstName: string;
  writeoffStartDate?: string | null; // ISO date string
  amount: number;
  serviceDate?: string | null; // ISO date string
  payerName: string;
}

// Available writeoff worklist types based on backend queries (matching dashboard statuses)
// Note: MyApprovals is excluded until approvals section is implemented
export const WRITEOFF_WORKLIST_TYPES = [
  'Draft',
  'InApproval',
  'Postable',
  'Rejected'
] as const;

export type WriteoffWorklistType = typeof WRITEOFF_WORKLIST_TYPES[number];

// Request parameters for worklist endpoint
export interface WriteoffWorklistEndpointRequest {
  type: WriteoffWorklistType;
  center: string;
  company: string;
}
